function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import { getWindowObject } from 'js-utils/feature-detection';
import { setWindowLocation } from 'js-utils/http';
import BaseGlobalHeader from 'eventbrite_design_system/globalHeader/GlobalHeader';
import { getHelpMenu, getOrganizeMenu, getLogoInfo, getSearchInfo, getBrowseEventsQuickLinks, getUserMenuInfo, getNonUserQuickLinks, getCreateEventCTA, isHomepage } from './utils';
import { ENV_SHAPE_PROP_TYPE, REQUEST_SHAPE_PROP_TYPE, USER_SHAPE_PROP_TYPE, FALLBACK_SUGGESTIONS } from './constants';
import { getSuggestions } from './utils/search';
var SEARCH_SUGGESTIONS_THROTTLE_AMOUNT = 300;
var getSuggestionsThrottled = throttle(getSuggestions, SEARCH_SUGGESTIONS_THROTTLE_AMOUNT);

var SiteHeader =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SiteHeader, _React$Component);

  function SiteHeader(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_handleSearchChange", function (searchQuery) {
      if (!_this.props.onSearchFocus) {
        getSuggestionsThrottled(searchQuery).then(function (searchSuggestions) {
          _this.setState({
            searchQuery: searchQuery,
            searchSuggestions: searchSuggestions
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchSubmit", function (query) {
      var LUX = getWindowObject('LUX');

      if (LUX) {
        LUX.mark('ch-search-sent');
      }

      setWindowLocation("/d/?q=" + query);
    });

    _this.state = {
      searchQuery: props.env.searchQuery || '',
      searchSuggestions: FALLBACK_SUGGESTIONS
    };
    return _this;
  }

  var _proto = SiteHeader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var LUX = getWindowObject('LUX');

    if (LUX) {
      LUX.mark('ch-search-ready');
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        env = _this$props.env,
        request = _this$props.request,
        user = _this$props.user,
        onSearchSelect = _this$props.onSearchSelect,
        hideSearchBar = _this$props.hideSearchBar,
        onSearchFocus = _this$props.onSearchFocus;
    var _this$state = this.state,
        searchQuery = _this$state.searchQuery,
        searchSuggestions = _this$state.searchSuggestions;
    var serverUrl = env.serverUrl,
        adminServerUrl = env.adminServerUrl,
        loginUrl = env.loginUrl,
        logoutUrl = env.logoutUrl,
        helpUrls = env.helpUrls,
        organizeUrls = env.organizeUrls,
        ebDomain = env.ebDomain,
        isNewAccountSettingsActive = env.isNewAccountSettingsActive,
        isManageOverviewActive = env.isManageOverviewActive;
    var requestPath = request.path;
    var isAuthenticated = user.isAuthenticated,
        canCreateEvents = user.canCreateEvents;
    var additionalMenus = [getHelpMenu(helpUrls, requestPath)];

    if (isHomepage(requestPath)) {
      additionalMenus = [getOrganizeMenu(organizeUrls, requestPath)].concat(additionalMenus);
    }

    return React.createElement(BaseGlobalHeader, {
      logoInfo: getLogoInfo(serverUrl, requestPath),
      searchInfo: getSearchInfo(serverUrl, searchQuery, searchSuggestions, hideSearchBar),
      quickLinks: getBrowseEventsQuickLinks(serverUrl, ebDomain, requestPath),
      userMenuInfo: getUserMenuInfo({
        serverUrl: serverUrl,
        adminServerUrl: adminServerUrl,
        logoutUrl: logoutUrl,
        requestPath: requestPath,
        user: user,
        isNewAccountSettingsActive: isNewAccountSettingsActive,
        isManageOverviewActive: isManageOverviewActive,
        showBrowseEvents: hideSearchBar
      }),
      additionalMenus: additionalMenus,
      nonUserQuickLinks: getNonUserQuickLinks(requestPath, isAuthenticated, loginUrl),
      callToActionInfo: getCreateEventCTA(serverUrl, ebDomain, requestPath, isAuthenticated, canCreateEvents),
      onSearchChange: this._handleSearchChange,
      onSearchSelect: onSearchSelect,
      onSearchFocus: onSearchFocus,
      onSearchSubmit: this._handleSearchSubmit
    });
  };

  return SiteHeader;
}(React.Component);

_defineProperty(SiteHeader, "propTypes", {
  env: ENV_SHAPE_PROP_TYPE.isRequired,
  request: REQUEST_SHAPE_PROP_TYPE.isRequired,
  user: USER_SHAPE_PROP_TYPE.isRequired,
  onSearchSelect: PropTypes.func,
  hideSearchBar: PropTypes.bool,
  onSearchFocus: PropTypes.func
});

export { SiteHeader as default };